import styled from 'styled-components';

export const CarouselTrack = styled.div`
    position: relative;
    width: 100%;
    max-width: 1920px;
    height: 332px;
    overflow: hidden;
`;

export const SlideLent = styled.div`
    position: relative;
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
`;

export const SlideWrap = styled.div<{ width: number }>`
    display: flex;
    justify-content: center;
    width: ${p => p.width}px;
    overflow: hidden;

    &:hover {
        cursor: pointer;
    }
`;
